import React from 'react';

const SecondaryButton = ({ content, type }) => {
  return (
    <button
      type={'button' ?? type}
      className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 m-2  hover:cursor-pointer"
    >
      {content}
    </button>
  );
};

export default SecondaryButton;
